const environment = process.env.REACT_APP_ENVIRONMENT;
let apiRequestUrl = '';

switch (environment) {
    case 'staging':
        apiRequestUrl = 'https://api-staging.hitchedagram.com';
        break;
    case 'production':
        apiRequestUrl = 'https://api.hitchedagram.com';
        break;
    default:
        apiRequestUrl = process.env.API_ENDPOINT || 'http://localhost:8080';
        break;
}

export default {
    apiRequestUrl
};